import { UntypedFormGroup } from '@angular/forms';
import {
    ClientPageSectionModel,
    PageSectionColumnModel
} from '../../domain/models/dynamic-form-schema.model';
import { serializeDate } from './serialize-date';

export interface ApplicationFormAnswerValueModel {
    fieldId: number;
    fieldName: string;
    answer: any;
}

export interface ApplicationPageValuePayloadModel {
    applicationId: number;
    applicationPageNumber: number;
    values: ApplicationFormAnswerValueModel[];
}

export function buildApplicationPageValueModel(
    sections: ClientPageSectionModel[],
    formGroup: UntypedFormGroup,
    applicationId: number,
    pageNumber: number
): ApplicationPageValuePayloadModel {
    const values: ApplicationFormAnswerValueModel[] = [];

    for (const section of sections) {
        for (const row of section.rows) {
            for (const field of row.fields) {
                if (!field.fieldId || !formGroup.contains(field.key)) {
                    continue;
                }

                values.push({
                    fieldId: field.fieldId,
                    fieldName: field.key,
                    answer: serializeAnswer(
                        field,
                        formGroup.get(field.key)?.value
                    )
                });
            }
        }
    }

    return {
        applicationId,
        applicationPageNumber: pageNumber,
        values
    };
}

function serializeAnswer(field: PageSectionColumnModel, value: any): any {
    switch (field.type) {
        case 'birth-date':
        case 'signature-date':
            return serializeDate(value);
        case 'multi-select':
            return Array.isArray(value) ? value : [];
        case 'select':
        case 'single-select':
        case 'number':
        case 'future-year-date':
        case 'income':
            return value === '' ? null : value;
        default:
            return value;
    }
}
